import { useEffect } from 'react';

import {
  Container,
  ContainerContent,
  GoBack,
  MouseKeyboardGuidePageContent,
} from '@/component';
import { VFlex } from '@/package';
import { useMainLayout } from '@/provider';

const MouseKeyboardPage = () => {
  const { setTitle } = useMainLayout();

  useEffect(() => {
    setTitle(() => (
      <VFlex items="center" className="gap-[10px]">
        <GoBack to={'/help'} />
        <div className="text-headline-sm font-semibold">
          Mouse & Keyboard guide
        </div>
      </VFlex>
    ));
  }, []);

  return (
    <Container>
      <ContainerContent>
        <MouseKeyboardGuidePageContent />
      </ContainerContent>
    </Container>
  );
};

export default MouseKeyboardPage;
